import { Component, OnInit } from '@angular/core';
import {Invoice} from "../../shared/model/invoice";
import {ActivatedRoute, Router} from "@angular/router";
import {CurrencyPipe, DatePipe} from "@angular/common";
import {Plan} from "../../shared/model/plan";
import {PayeeCustomer} from "../../shared/model/payee_customer";
import {LocalStripeService} from "../../shared/services/stripe/local.stripe.service";

@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.component.html',
  styleUrls: ['./invoice-detail.component.css']
})
export class InvoiceDetailComponent implements OnInit {
   endingBalance: string;
   startingBalance: string;
   planAmount: string;
   invoice:Invoice;
   invoiceDate:string;
   periodStart:string;
   periodEnd:string;
   amountDue:string;
   plan: Plan;
   customer:PayeeCustomer;
   invoiceIdF8:string;

  constructor(
    private route:ActivatedRoute,
    private datePipe: DatePipe,
    private currencyPipe:CurrencyPipe,
    private stripeService:LocalStripeService,
    private router:Router,


  ) {
    route.data
      .subscribe((data:{invoice:Invoice}) =>
        {
          this.invoice = data.invoice;
          // console.log(this.invoice);
          this.stripeService.getStripeCustomerByKey(this.invoice.customer)
            .subscribe(
              result => {
                this.customer = result;
                // console.log(this.customer);
              }

            );
        }
      )
  }

  ngOnInit() {

    this.invoiceIdF8 = this.invoice.id.substr(4,8);
    this.invoiceDate = this.formattDate(this.invoice.date);
    this.periodStart = this.formattDate(this.invoice.lines[0].period.start);
    this.periodEnd  = this.formattDate(this.invoice.lines[0].period.end);
    this.amountDue = this.formatCurrency(this.invoice.amount_due,this.invoice.currency);
    this.plan = this.invoice.lines[0].plan;
    this.planAmount = this.formatCurrency(this.plan.amount,this.plan.currency);
    this.startingBalance = this.formatCurrency(this.invoice.starting_balance,this.invoice.currency);
    this.endingBalance = this.formatCurrency(this.invoice.ending_balance,this.invoice.currency);


  }

  formattDate(dt){
    // dateFormat(ret, "dddd, mmmm dS, yyyy, h:MM:ss TT");

    let ret = this.datePipe.transform(new Date(dt * 1000), 'yMMMd');
    // ret = {{ret | date: 'dd/MM/yyyy H:mm' }}
    return ret
  }


  formatCurrency(amt,symb){
    // console.log(symb);
    let symbStr = symb.toString().toUpperCase();
    let ret = this.currencyPipe.transform(amt/100, symb, true)
    // TODO : URGENt Before Production Make currency Dynamic
    return ret
  }


  public cancel() {

    let restaurantId = this.customer.restaurant_id;

    let navigateRoute = './restaurants/'+ restaurantId;

    navigateRoute = navigateRoute +'/invHist';

    this.router.navigate([navigateRoute]);

  }

  printInvoice(){
    let popupWinindow
    let invoicePage = document.getElementById("invoice").innerHTML;
    popupWinindow = window.open('', '_blank', 'width=1500,height=1000,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write(`
          <html>
            <head>
           </head>
           <body onload="window.print()"> 
           <div>

          <div class="panel panel-heading" style="text-align: center;">
            <label>Invoice for `+this.plan.statement_descriptor+` </label>
          </div>
          <br><br>
          <div class="panel-body">
            <div class="row"><div  style="margin-left:25%;"> Invoice ID:        ` + this.invoiceIdF8 + `</div></div>
            <br>
            <div class="row"><div  style="margin-left:25%;"> Period Start Date: `+ this.periodStart + `</div></div>
            <div class="row"><div  style="margin-left:25%;"> Period End Date:   `+ this.periodEnd + `</div></div>
          <br>

            <div class="panel panel-default">
              <div class="panel-body">
                <div class="row"><div  style="margin-left:25%;"> Invoice Date:   `+ this.invoiceDate+`</div></div>
                <div class="row"><div  style="margin-left:25%;"> Invoice Amount:  `+this.amountDue+`  </div></div>
                <div class="row"><div  style="margin-left:25%;"> Starting Balance:`+this.startingBalance+`  </div></div>
                <div class="row"><div  style="margin-left:25%;"> Ending Balance:  `+this.endingBalance+`  </div></div>
                <div class="row"><div  style="margin-left:25%;"> Billing:         `+this.invoice.billing+`</div></div>
              </div>
            </div>

            <br>

            <div class="panel panel-default">
              <div class="panel panel-heading" style="text-align: center;"><label>Subscription </label></div>
              <br><br>
              <div class="panel-body">
                <div class="row"><div  style="margin-left:25%;"> Plan Name:  `+this.plan.name+`</div></div>
                <div class="row"><div  style="margin-left:25%;"> Price:      `+this.planAmount+`</div></div>
                <div class="row"><div  style="margin-left:25%;"> Interval:   `+this.plan.interval_count+` `+this.plan.interval+`</div></div>

              </div>
            </div>

            <br>

            <div class="panel panel-default">
              <div class="panel panel-heading" style="text-align: center;"><label>Customer </label></div>
              <br><br>
              <div class="panel-body">
                <div class="row"><div  style="margin-left:25%;"> Restaurant Name:   `+this.customer.description+`</div></div>
                <div class="row"><div  style="margin-left:25%;"> Email:             `+this.customer.email+`</div></div>
              </div>
            </div>




           </div>
           </body></html>`);
    popupWinindow.document.close();

  }


}



// WEBPACK FOOTER //
// ./src/app/invoice/invoice-detail/invoice-detail.component.ts